export const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    color: '#7F8FA4',
    fontWeight: 600,
  },
  selectContainer: {
    position: 'relative',
  },
  select: {
    width: '100%',
    '& .MuiSelect-root': {
      height: '40px',
      padding: '0 15px',
      backgroundColor: '#fff',
      border: '1px solid #E8E8E8',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      color: '#546b81 !important',
      fontSize: '14px',
      fontFamily: 'Proxima Nova, sans-serif',
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      display: 'none',
    },
  },
  expandedContent: {
    position: 'absolute',
    top: '-21px',
    left: '-161px',
    backgroundColor: '#fff',
    border: '1px solid #E8E8E8',
    borderRadius: '4px',
    padding: '15px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    zIndex: 1000,
  },
  input: {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      fontFamily: 'Proxima Nova, sans-serif',
    },
    marginBottom: '15px',
  },
  betweenInputs: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '15px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
    },
  },
  updateButton: {
    backgroundColor: '#E85B6B',
    color: 'white',
    height: '35px',
    width: '80px',
    '&:hover': {
      backgroundColor: '#D64D5D',
    },
  },
  menuItem: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    fontFamily: 'Proxima Nova, sans-serif',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
    '&.Mui-selected': {
      backgroundColor: '#F5F5F5 !important',
      color: '#E85B6B',
      '&:hover': {
        backgroundColor: '#F5F5F5 !important',
      },
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}
